import { format, isValid, parse } from "date-fns";

export const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export function normalizeValue(selectedValue) {
  return selectedValue instanceof Date
    ? selectedValue
    : typeof selectedValue === "string" && selectedValue
      ? (() => {
          const d = parse(selectedValue, "yyyy-MM-dd", new Date());
          return isValid(d) ? d : null;
        })()
      : null;
}

export function normalizeTimeValue(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date && isValid(value)) {
    return value;
  }

  if (typeof value === "string") {
    const timeParsed = parse(value, "HH:mm", new Date());
    if (isValid(timeParsed)) {
      return timeParsed;
    }

    const dateParsed = new Date(value);
    if (isValid(dateParsed)) {
      return dateParsed;
    }
  }

  return null;
}

// Helper function to create active chip label
export function createActiveChipLabel(value, filterType, trueLabel = "Yes", falseLabel = "No") {
  if (!value) {
    return "";
  }

  switch (filterType) {
    case "MultiSelectSearch":
      if (Array.isArray(value)) {
        return value.length > 0 ? `${value.join(", ")}` : "";
      }
      return value.toString();
    case "DateRange":
    case "RangeSlider": {
      const gte = formatValue(value.__gte);
      const lte = formatValue(value.__lte);

      if (gte && lte) {
        return `${gte} - ${lte}`;
      }
      if (gte) {
        return `From ${gte}`;
      }
      if (lte) {
        return `To ${lte}`;
      }
      return "";
    }
    case "SearchOptionGroup":
      return value === "true" ? trueLabel : value === "false" ? falseLabel : "";
    case "DatePicker":
      return formatValue(value);
    default:
      return value.toString();
  }
}

function formatValue(value) {
  if (isNumeric(value)) {
    return formatter.format(Number(value));
  }
  if (isValidDate(value)) {
    const d = parse(value, "yyyy-MM-dd", new Date());
    return isValid(d) ? format(d, "MM/dd/yyyy") : "";
  }
  return "";
}

function isNumeric(value) {
  return (
    value !== null &&
    value !== undefined &&
    String(value).trim() !== "" &&
    Number.isFinite(Number(value))
  );
}

function isValidDate(value) {
  return typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value);
}
